import { TireIndustry } from "@/@types/Tire";
import { ApiClient } from "../../ApiClient";
import { GetTireIndustryResponse } from "../schema/GetTireIndustryResponse";
import { mapTireIndustry } from "../../mappers/tireIndustryMapper";

export const getTireIndustry = async (): Promise<TireIndustry[]> => {
    const client = ApiClient.getInstance()

    const response = await client.get<GetTireIndustryResponse>('tires/industries')

    const mappedResponse = mapTireIndustry(response.data)

    return mappedResponse;
}